/*
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2019-12-06 13:33:57
 * @LastEditors: sueRimn
 * @LastEditTime: 2019-12-06 14:08:46
 */
import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js